/**
 * Validates a date-time answer string and returns the matching moment format
 * token, or `false` when the string doesn't match an accepted format.
 *
 * Mirrors audit-lite's `checkDateFormat` so completion + validation stay aligned:
 *   - "DD-MM-YYYY"        e.g. 31-12-1997
 *   - "DD-MM-YYYY HH:mm"  e.g. 31-12-1997 22:23
 */
export const checkDateFormat = (dateStr: string): string | false => {
  // Regex for "DD-MM-YYYY"
  const dateOnlyRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;

  // Regex for "DD-MM-YYYY HH:mm"
  const dateTimeRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4} (0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/;

  if (dateOnlyRegex.test(dateStr)) {
    return 'DD-MM-YYYY';
  } else if (dateTimeRegex.test(dateStr)) {
    return 'DD-MM-YYYY HH:mm';
  }

  return false;
};
